import {LUX_INPUT_TYPE} from '@lux/wardrobe-lib'

export const columns = [
    {
        field: 'storeName',
        header: 'modals.new.activity.section.distribution.table.store.name',
        filterType: LUX_INPUT_TYPE.text,
    },
    {
        field: 'storeId',
        header: 'modals.new.activity.section.distribution.table.banner',
        filterType: LUX_INPUT_TYPE.text,
    },
]
